import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import { validateMassUpload } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { useState, useEffect } from "react";
import SelectInput_3 from "../../../../components/SelectInput_3";
import CustomLoader from "../../../../components/CustomLoader";
import CancelButton from "../../../../components/CancelButton";
import { useStates } from "../../hooks/useStates";
import { toast } from "../../../../components/toastNotification";
import { useGetProducerCodeListByCarrierId } from "../hooks/useGetProdCodeByCarrierId";
import { useGetLobTypeOptions } from "../hooks/useGetLobTypeOptions";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useGetProdCodeType } from "../hooks/useGetProdCodeType";
import { useGetCodeLevel } from "../hooks/useGetCodeLevel";
import useGetEmployees from "../hooks/useGetEmployees";
import { useGetCarrierNameList } from "../../Carrier/hooks/useGetCarrierNameList";
import { useGetMGA } from "../hooks/useGetMGA";
import { useProdFranchiseType } from "../hooks/useGetProdFranchiseTypes";
import { useCarrierProgram } from "../../../Utilities/ProducerConfiguration/CarrierProgram/hooks/useCarrierProgram";
import CheckBoxLabelHookForm from "../../../../components/CheckBoxLabelHookForm";
import { useForm } from "react-hook-form";
import { franchiseCheckBox } from "../atom";
import MultiSelectInputForProdCode from "../../../../components/MultiSelectInputForProdCode";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import { useGetBilling } from "../hooks/useGetBilling";
import TextAreaHookForm from "components/TextAreaHookForm";

const extractCrossSale = (crossSale: any) => {
  const crossSaleValues = Array.isArray(crossSale)
    ? crossSale
    : crossSale.split(",");
  return crossSaleValues.map((val: string) => ({
    label: val.trim(),
    value: val.trim(),
  }));
};

const getLobOptions = (LOBQuery: any) =>
  LOBQuery?.filter((data: any) => data.isActive === true).map(
    (resData: any) => ({
      label: resData.lobname,
      value: resData.lobid,
    }),
  );

const getMgaList = (mga: any) =>
  mga
    ?.filter((data: any) => data.isActive === true)
    .map((x: any) => ({
      label: x.mga1,
      value: x.id,
    }));

const getFranchiseTypeList = (franchiseType: any) =>
  franchiseType
    ?.filter((data: any) => data.isActive === true)
    .map((x: any) => ({
      label: x.franchiseTypeName,
      value: x.franchiseTypeId,
    }));

const getCarrierProgramOpt = (carrierProgramQuery: any) =>
  carrierProgramQuery
    ?.filter((data: any) => data.isActive === true && data.programName !== "")
    .map((x: any) => ({
      label: x.programName,
      value: x.programName,
      carrierId: x.carrierId,
      isActive: x.isActive,
    })) ?? [];

const getCarriers = (carriersQuery: any) =>
  Array.from(
    new Map(
      carriersQuery
        ?.filter((x: any) => x.isActive === true)
        ?.map((x: any) => [
          x.masterCarrierId,
          {
            label: x.carrierName,
            value: x.masterCarrierId,
          },
        ]),
    ).values(),
  );

const getCodeLevelOptions = (codeLevels: any) =>
  codeLevels
    ?.filter((cLevels: any) => cLevels.isActive === true)
    .map((x: any) => ({
      label: x.codeLevelName,
      value: x.codeLevelId,
    }));

const getProdTypesOptions = (prodTypes: any) =>
  prodTypes
    ?.filter((ptypes: any) => ptypes.isActive === true)
    .map((x: any) => ({
      label: x.producerCodeTypesName,
      value: x.producerCodeTypesId,
    }));

const getEmpFranchisesOpts = (employeeQuery: any) =>
  employeeQuery
    ?.filter(
      (x: any) =>
        x.employeeId !== null &&
        x.employeeId !== "" &&
        x.employeeTypeName === "Franchise" &&
        x.status !== "Terminated",
    )
    ?.map(
      (x: {
        employeeId: number;
        fullname: string;
        employeenumber: string;
      }) => ({
        label: x.fullname + " - " + x.employeenumber,
        value: x.employeeId?.toString(),
      }),
    );

const getConfieEmpOpts = (employeeQuery: any) =>
  employeeQuery
    ?.filter(
      (x: any) =>
        x.employeeId !== null &&
        x.employeeId !== "" &&
        x.employeeTypeName !== "Franchise" &&
        x.status !== "Terminated",
    )
    ?.map(
      (x: {
        employeeId: number;
        fullname: string;
        employeenumber: string;
      }) => ({
        label: x.fullname + " - " + x.employeenumber,
        value: x.employeeId?.toString(),
      }),
    );

const getMasterCodeOpts = (allProducerCodeListByCarrier: any) =>
  allProducerCodeListByCarrier
    ?.filter((x: any) => x.officeName !== "")
    ?.map((x: any) => ({
      label: x.producerCode + " - " + x.officeName,
      value: x.carrierProducerCodeId,
    }));

const getRollUpCodeOpts = (allProducerCodeListByCarrier: any) =>
  allProducerCodeListByCarrier
    ?.filter((x: any) => x.officeName !== "")
    .map((x: any) => ({
      label: x.producerCode + " - " + x.officeName,
      value: x.carrierProducerCodeId,
    }));

const getRollUpCodeActiveOpts = (allProducerCodeListByCarrier: any) =>
  allProducerCodeListByCarrier
    ?.filter((x: any) => x.officeName !== "")
    .map((x: any) => ({
      label: x.producerCode + " - " + x.officeName,
      value: x.carrierProducerCodeId,
      isActive: x.isActive,
      isFranchise: x.isFranchise,
    }));

const getAllStatesOpt = (states: any) =>
  states?.map((x: any) => ({
    label: x.state,
    value: x.state.toString(),
  }));

const getBillingOpt = (billing: any) =>
  billing?.map((x: any) => ({
    value: x.billingId,
    label: x.billingName,
  }));

const checkSubmitValidation = (formData: any) => {
  let isAssociatedToValid = false;
  let isRollUpCode = true;
  let isMasterCode = true;
  if (formData.associatedTo === "Office") {
    isAssociatedToValid = !!(formData.officeCode && formData.storeNumber);
  } else {
    isAssociatedToValid = !!formData.producer;
  }

  if (formData.rollUpCodeStatus === "Active") {
    isRollUpCode = !!formData.rollUpCode;
  }

  if (formData.masterCodeStatus === "Active") {
    isMasterCode = !!formData.masterCode;
  }

  let isCarrierValid = false;
  if (formData.carrierName?.toLowerCase() === "national general") {
    isCarrierValid = !!formData.princetonAgentCode;
  } else {
    isCarrierValid = !!formData.carrierName;
  }

  return (
    formData.producerCode &&
    isAssociatedToValid &&
    formData.lineOfBusiness &&
    formData.carrierName &&
    formData.crossSaleList &&
    formData.codeLevel &&
    formData.producerCodeType &&
    isRollUpCode &&
    isMasterCode &&
    isCarrierValid
  );
};

const buildUpdatedRowPayload = (formData: any, carrierProg: any) => {
  const programName = carrierProg || formData.program || "";

  let officeCode = "";
  if (formData.associatedTo !== "Producer") {
    officeCode = formData.officeCode || "";
  }

  return {
    ...formData,
    id: formData.id,
    carrierName: formData.carrierName,
    address: formData.address || "",
    city: formData.city || "",
    state: formData.state || "",
    producerCode: formData.producerCode,
    producerSubCode: formData.producerSubCodes || "",
    lineOfBusiness: formData.lineOfBusiness,
    storeNumber: formData.storeNumber,
    officeCode: officeCode,
    producer: formData.producer || "",
    mAproducerCodes:
      formData.mAproducerCodes === null ? "" : String(formData.mAproducerCodes),
    programName: programName,
    distributionChannel: formData.distributionChannel || "",
    issuedToList: formData.issuedToList || null,
    issuedTo: formData.issuedTo || "",
  };
};

const processIssuedToLoop = (
  formData: any,
  empFranchisesOpts: any,
  confieEmpOpts: any,
  selectedIssuedTo: any,
) => {
  if (formData.isFranchise === true) {
    for (let i = 0; i < formData.issuedToList?.length; i++) {
      empFranchisesOpts
        ?.filter((x: any) => x.value.toString() === formData.issuedToList[i])
        .map((x: any) =>
          selectedIssuedTo.push({
            label: x.label,
            value: x.value,
          }),
        );
    }
  } else {
    for (let i = 0; i < formData.issuedToList?.length; i++) {
      confieEmpOpts
        ?.filter((x: any) => x.value.toString() === formData.issuedToList[i])
        .map((x: any) => {
          selectedIssuedTo.push({
            label: x.label,
            value: x.value,
          });
        });
    }
  }
};

const processCrossSaleLoop = (
  formData: any,
  allStatesOpt: any,
  selectedCrossSale: any,
) => {
  for (let i = 0; i < formData.crossSaleList?.length; i++) {
    allStatesOpt
      ?.filter((x: any) => x.value === formData.crossSaleList[i])
      .map((x: any) =>
        selectedCrossSale.push({
          label: x.label,
          value: x.value,
        }),
      );
  }
};

const determineExceptions = (formData: any) => {
  const mappingStatus = new Set(["true", "false", ""]);
  const cdrcInput = formData.exceptionCDRC.trim().toLowerCase();
  const keeperInput = formData.exceptionKeeper.trim().toLowerCase();
  const al3Input = formData.exceptionAL3.trim().toLowerCase();

  const cdrcException = !!(
    cdrcInput &&
    mappingStatus.has(cdrcInput) &&
    cdrcInput !== "false"
  );
  const keeperException = !!(
    keeperInput &&
    mappingStatus.has(keeperInput) &&
    keeperInput !== "false"
  );
  const al3Exception = !!(
    al3Input &&
    mappingStatus.has(al3Input) &&
    al3Input !== "false"
  );

  return { cdrcException, keeperException, al3Exception };
};

const processRevalidateData = (
  updatedRowDetails: any,
  origData: any,
  res: any,
) => {
  const id = new Set(updatedRowDetails.map((d: any) => d.id));
  const newData = origData?.filter((d: any) => !id.has(d.id)) || [];
  res.map((prodCode: any) => {
    newData.push(prodCode);
  });
  return newData;
};

const partitionRevalidateData = (newData: any) => {
  const tempValidData: any = [null];
  const tempInvalidData: any = [null];
  newData.map((prodCode: any) => {
    if (prodCode.isValid) tempValidData.push(prodCode);
    else tempInvalidData.push(prodCode);
  });
  return { tempValidData, tempInvalidData };
};

export const MassUploadFullView = ({
  data,
  isEdit = false,
  updateRow,
  setShowEdit,
  setOrigData,
  setAllData,
  origData,
  Cancel,
  setValidData,
  setInvalidData,
  setShow,
  setDisplayNote,
  selectedTab,
  handleSelectedTab,
}) => {
  const associatedOptions = [
    { label: "Office", value: "Office" },
    { label: "Producer", value: "Producer" },
  ];
  const [formData, setFormData] = useState(data);
  const [updatedRowDetails] = useState<any>([]);
  const [selectedIssuedTo, setSelectedIssuedTo] = useState<any>([]);
  const [selectedCrossSale, setSelectedCrossSale] = useState<any>([]);
  const [, setDefaultProducer] = useState("");
  const [carrierProg, setCarrierProg] = useState([]);
  const user = useRecoilValue(accountAtom);
  const useFormMethods = useForm();
  const { setValue, register, watch } = useFormMethods;
  const [, setFranchiseCheckBoxValue] = useRecoilState(franchiseCheckBox);

  const superUser = user?.isNonFranchise && user?.isFranchise;
  const franchise = !user?.isNonFranchise && user?.isFranchise;

  useEffect(() => {
    if (formData?.crossSale) {
      setSelectedCrossSale(extractCrossSale(formData.crossSale));
    } else {
      setSelectedCrossSale([]);
    }
  }, [formData?.crossSale]);

  useEffect(() => {
    if (superUser && formData.isFranchise !== null) {
      if (superUser && formData.isFranchise === true) {
        setValue("isFranchise", true);
      } else if (superUser && formData.isFranchise === false) {
        setValue("isFranchise", false);
      }
    } else if (franchise) {
      setValue("isFranchise", true);
    } else {
      setValue("isFranchise", false);
    }
  }, [useFormMethods.watch("isFranchise"), superUser, franchise]);

  const { data: LOBQuery } = useGetLobTypeOptions();
  const loboptions = getLobOptions(LOBQuery);

  const { data: mga } = useGetMGA();
  const mgaList = getMgaList(mga);

  const { data: franchiseType } = useProdFranchiseType();
  const franchiseTypeList = getFranchiseTypeList(franchiseType);

  const { data: carrierProgramQuery, isLoading: carrierProgramLoading } =
    useCarrierProgram();
  const carrierProgramOpt = getCarrierProgramOpt(carrierProgramQuery);

  const { data: carriersQuery, isLoading: carrierLoading } =
    useGetCarrierNameList();
  const carriers: any = getCarriers(carriersQuery);

  const { data: employeeQuery } = useGetEmployees();
  const { data: codeLevels } = useGetCodeLevel();
  const codeLevelOptions = getCodeLevelOptions(codeLevels);

  const { data: prodTypes } = useGetProdCodeType();
  const prodTypesOptions = getProdTypesOptions(prodTypes);

  const { data: allProducerCodeListByCarrier } =
    useGetProducerCodeListByCarrierId(formData?.masterCarrierID);

  const empFranchisesOpts = getEmpFranchisesOpts(employeeQuery);
  const confieEmpOpts = getConfieEmpOpts(employeeQuery);

  const masterCodeOpts = getMasterCodeOpts(allProducerCodeListByCarrier);
  const rollUpCodeOpts = getRollUpCodeOpts(allProducerCodeListByCarrier);
  const rollUpCodeActiveOpts = getRollUpCodeActiveOpts(
    allProducerCodeListByCarrier,
  );

  const codeStatus = [
    { label: "Active", value: true },
    {
      label: "Inactive",
      value: false,
    },
  ];
  const { data: states } = useStates();
  const allStatesOpt = getAllStatesOpt(states);

  const { data: billing } = useGetBilling();
  const billingOpt = getBillingOpt(billing);

  const associatedToVal = formData.associatedTo === "Office" ? true : false;

  const getLabel = (e: any) => (e === null ? "" : e.label);
  const getBoolString = (e: any) => (e.target.checked ? "True" : "False");

  const fieldHandlers = {
    LOB: (e: any) => ({ lineOfBusiness: getLabel(e) }),
    program: (e: any) => ({ program: getLabel(e) }),
    mga: (e: any) => ({ mga: getLabel(e) }),
    franchiseType: (e: any) => ({ franchiseType: getLabel(e) }),
    codeLevel: (e: any) => ({ codeLevel: getLabel(e) }),
    billingId: (e: any) => ({ billingName: getLabel(e) }),
    masterCode: (e: any) => ({ masterCode: getLabel(e) }),
    rollUpId: (e: any, rollUpId: any) => ({
      rollUpCode: getLabel(e),
      rollUpId: rollUpId ?? 0,
    }),

    carrierName: (e: any) => {
      const carrierId = e === null ? 0 : e.value;
      const selectedCarrier = carriersQuery.find(
        (c: any) => c.masterCarrierId === carrierId,
      );

      setCarrierProg([]);

      return {
        carrierName: e === null ? null : e.label,
        masterCarrierID: carrierId,
        rollUpCode: "",
        rollUpId: 0,
        masterCode: "",
        masterCodeStatus: "Inactive",
        rollUpCodeStatus: "Inactive",
        isInProduction: selectedCarrier?.isDigitized === true,
      };
    },

    associatedTo: (e: any) => {
      if (e.label === "Office") {
        setDefaultProducer("");
        return { associatedTo: getLabel(e), producer: null };
      }
      return { associatedTo: getLabel(e), storeNumber: "", officeCode: "" };
    },

    producer: (e: any) => ({ producer: e, storeNumber: "", officeCode: "" }),

    producerCodeType: (e: any) => ({
      producerCodeTypeId: e === null ? 0 : e.value,
      producerCodeType: getLabel(e),
    }),

    masterCodeStatus: (e: any) => ({
      masterCodeStatus: e === true ? "Active" : "Inactive",
    }),
    rollUpCodeStatus: (e: any) => ({
      rollUpCodeStatus: e === true ? "Active" : "Inactive",
    }),

    issuedTo: (e: any) => {
      setSelectedIssuedTo(e);
      const empList = [null, ...(e || []).map((x: any) => x.value)];
      return { issuedToList: e === null ? 0 : empList };
    },

    crossSale: (e: any) => {
      setSelectedCrossSale(e);
      const stateList = [null, ...(e || []).map((x: any) => x.value)];
      return { crossSaleList: e === null ? [] : stateList };
    },

    isFranchise: (e: any) => ({
      isFranchise: e === null ? "" : e.target.checked,
    }),
    exceptionCDRC: (e: any) => ({ exceptionCDRC: getBoolString(e) }),
    exceptionKeeper: (e: any) => ({ exceptionKeeper: getBoolString(e) }),
    exceptionAL3: (e: any) => ({ exceptionAL3: getBoolString(e) }),
    notes: (e: any) => ({ notes: e.target.value }),
  };

  const handleChange = (event: any, field: any, rollUpId: any) => {
    const handler = fieldHandlers[field as keyof typeof fieldHandlers];

    if (handler) {
      const stateUpdates = handler(event, rollUpId);
      setFormData((prevData: any) => ({ ...prevData, ...stateUpdates }));
    } else if (event?.target?.name) {
      setFormData((prevData: any) => ({
        ...prevData,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleSubmit = () => {
    if (checkSubmitValidation(formData)) {
      updateRow(formData);
      updatedRowDetails.push(buildUpdatedRowPayload(formData, carrierProg));
      revalidateProdCode();
    } else {
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error",
      );
    }
  };

  const revalidateProdCode = () => {
    validateMassUpload(updatedRowDetails).then((res: any) => {
      const newData = processRevalidateData(updatedRowDetails, origData, res);
      setOrigData(newData);
      setAllData(newData);

      if (selectedTab === "Invalid" || selectedTab === "Valid") {
        handleSelectedTab(selectedTab, newData);
      }

      const { tempValidData, tempInvalidData } =
        partitionRevalidateData(newData);

      setValidData(tempValidData);
      setInvalidData(tempInvalidData);
    });
    setShow(false);
    setShowEdit(false);
    setDisplayNote(true);
  };

  useEffect(() => {
    setDefaultProducer(
      formData.isFranchise
        ? empFranchisesOpts?.filter(
            (x: any) => x.value.toString() === formData.producer,
          )
        : confieEmpOpts?.filter(
            (x: any) => x.value.toString() === formData.producer,
          ),
    );
    setCarrierProg(
      carrierProgramOpt?.filter((x: any) => x.label === formData.program),
    );

    processIssuedToLoop(
      formData,
      empFranchisesOpts,
      confieEmpOpts,
      selectedIssuedTo,
    );
    processCrossSaleLoop(formData, allStatesOpt, selectedCrossSale);
  }, []);

  useEffect(() => {
    const { cdrcException, keeperException, al3Exception } =
      determineExceptions(formData);

    setValue("isCDRCException", cdrcException);
    setValue("isKeeperException", keeperException);
    setValue("isAL3Exception", al3Exception);

    setFormData({
      ...formData,
      exceptionCDRC: String(cdrcException),
      exceptionKeeper: String(keeperException),
      exceptionAL3: String(al3Exception),
    });
  }, []);

  const isZOffice =
    formData.officeCode?.toLowerCase().startsWith("z") && formData.isFranchise;

  const franchiseLabel = isZOffice
    ? "Freeway Franchise"
    : formData.franchiseType;

  const defaultFranchiseType = franchiseTypeList?.find(
    (x: any) => x.label === franchiseLabel,
  );

  const maxLength = 350;

  const notesValue = formData.notes || "";
  const isNotesTooLong = notesValue.length > maxLength;

  const selectedMasterCode =
    formData.masterCodeStatus === "Active"
      ? masterCodeOpts?.find((x) => x.label === formData.masterCode)
      : null;

  const selectedRollUpCode =
    formData.rollUpCodeStatus === "Active"
      ? rollUpCodeOpts?.find((x) => x.label === formData.rollUpCode)
      : null;

  const selectedRollUpCodeStatus =
    codeStatus?.find((x) => x.label === formData.rollUpCodeStatus) ?? null;

  const selectedMasterCodeStatus =
    codeStatus?.find((x) => x.label === formData.masterCodeStatus) ?? null;

  const isCarrierNatSafeDrivers = formData.masterCarrierID === 174;

  const setExceptionCheckBoxes = (val: boolean) => {
    setValue("isCDRCException", val);
    setValue("isAL3Exception", val);
    setValue("isKeeperException", val);

    setFormData((prevData: any) => ({
      ...prevData,
      exceptionCDRC: val ? "True" : "False",
      exceptionAL3: val ? "True" : "False",
      exceptionKeeper: val ? "True" : "False",
    }));
  };

  return (
    <div>
      {mgaList && !carrierLoading && !carrierProgramLoading ? (
        <div className="w-full">
          <div className="p-2 space-y-4 border-l-2 border-quinary  rounder-r-none box-shadow mb-2">
            <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 text-xs pb-1">
              {isEdit && (
                <div className="flex flex-row  justify-between items-center pb-1 mt-3 mx-3">
                  <div className="text-sm text-primary font-bold">
                    Edit Producer Code Mass Upload
                  </div>
                  <div className="flex justify-between gap-2">
                    <SaveButton onClick={handleSubmit} />
                    <CancelButton onClick={Cancel} />
                  </div>
                </div>
              )}
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Carrier: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2 ">
                      Carrier:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={carriers?.filter(
                        (x) => x.value === formData.masterCarrierID,
                      )}
                      className="expandedLabel"
                      name="carrierName"
                      options={carriers}
                      onChange={(e) => {
                        handleChange(e ? e : null, "carrierName", null);
                        setExceptionCheckBoxes(false);

                        if (e?.value === 174) {
                          setExceptionCheckBoxes(true);
                        }
                      }}
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.carrierName}
                    </div>
                  )}
                </div>
                {superUser && (
                  <div className="grid grid-cols-3">
                    {isEdit ? (
                      <div className="expandedLabel text-left mr-2 mt-1">
                        isFranchise:
                      </div>
                    ) : (
                      <div className="expandedLabel text-left mr-2 ">
                        isFranchise:
                      </div>
                    )}
                    {isEdit ? (
                      <CheckBoxLabelHookForm
                        name="isFranchise"
                        type="checkbox"
                        disabled={!associatedToVal}
                        register={register}
                        className=""
                        onClick={(e) => {
                          setFranchiseCheckBoxValue(e.target.checked);
                          handleChange(e ? e : null, "isFranchise", null);
                        }}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {formData.isFranchise === true ? "True" : "False"}
                      </div>
                    )}
                  </div>
                )}
                <div className="grid grid-cols-3">
                  {isEdit &&
                  formData.carrierName?.toLowerCase() === "national general" ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Agent ID: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    formData.carrierName?.toLowerCase() ===
                      "national general" && (
                      <div className="text-right mr-2">Agent ID:</div>
                    )
                  )}
                  {isEdit &&
                  formData.carrierName?.toLowerCase() === "national general" ? (
                    <TextInput
                      value={formData.princetonAgentCode}
                      className="expandedLabel"
                      name="princetonAgentCode"
                      onChange={(e) => {
                        handleChange(e ? e : null, "princetonAgentCode", null);
                      }}
                    />
                  ) : (
                    formData.carrierName?.toLowerCase() ===
                      "national general" && (
                      <div className="font-medium lg:text-left">
                        {formData.princetonAgentCode}
                      </div>
                    )
                  )}
                </div>

                <div className="grid grid-cols-3">
                  {isEdit &&
                  formData.carrierName?.toLowerCase() === "national general" ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Master Agent ID:
                    </div>
                  ) : (
                    formData.carrierName?.toLowerCase() ===
                      "national general" && (
                      <div className="ext-right mr-2">Master Agent ID:</div>
                    )
                  )}
                  {isEdit &&
                  formData.carrierName?.toLowerCase() === "national general" ? (
                    <TextInput
                      value={formData.masterAgentPrincetonId}
                      className="expandedLabel"
                      name="masterAgentPrincetonId"
                      onChange={(e) => {
                        handleChange(
                          e ? e : null,
                          "masterAgentPrincetonId",
                          null,
                        );
                      }}
                    />
                  ) : (
                    formData.carrierName?.toLowerCase() ===
                      "national general" && (
                      <div className="font-medium lg:text-left">
                        {formData.masterAgentPrincetonId}
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="border-b border-gray-200"></div>
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Distribution Channel:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Distribution Channel:
                    </div>
                  )}
                  {isEdit ? (
                    <TextInputHookFormDisabled
                      type="text"
                      value={formData.distributionChannel}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.distributionChannel}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Associated To: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2 ">
                      Associated To:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={associatedOptions?.filter(
                        (x) => x.value === formData.associatedTo,
                      )}
                      className="expandedLabel"
                      isClearable={false}
                      isDisabled={
                        superUser
                          ? useFormMethods.watch("isFranchise")
                          : franchise
                      }
                      name="associatedTo"
                      options={associatedOptions}
                      onChange={(e) => {
                        handleChange(e ? e : null, "associatedTo", null);
                      }}
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.associatedTo}
                    </div>
                  )}
                </div>
                {formData.associatedTo === "Office" && (
                  <div className="grid grid-cols-3 ">
                    {isEdit ? (
                      <div className="expandedLabel text-left mr-2 mt-1">
                        Office Code:{" "}
                        {formData.associatedTo !== "Office" ? (
                          <></>
                        ) : (
                          <span className="text-xs text-red-500">* </span>
                        )}
                      </div>
                    ) : (
                      <div className="expandedLabel text-left mr-2">
                        Office Code:
                      </div>
                    )}
                    {isEdit ? (
                      <TextInput
                        disabled={!associatedToVal}
                        type="text"
                        name="officeCode"
                        value={formData.officeCode}
                        className="expandedLabel"
                        onChange={(e) => handleChange(e, "officeCode", null)}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {" "}
                        {formData.officeCode}
                      </div>
                    )}
                  </div>
                )}
                {formData.associatedTo === "Office" && (
                  <div className="grid grid-cols-3 ">
                    {isEdit ? (
                      <div className="expandedLabel text-left mr-2 mt-1">
                        Store Number:{" "}
                        {formData.associatedTo !== "Office" ? (
                          <></>
                        ) : (
                          <span className=" text-xs text-red-500">* </span>
                        )}
                      </div>
                    ) : (
                      <div className="expandedLabel text-left mr-2">
                        Store Number:
                      </div>
                    )}
                    {isEdit ? (
                      <TextInput
                        disabled={!associatedToVal}
                        value={formData.storeNumber}
                        className="expandedLabel"
                        name="storeNumber"
                        onChange={(e) => {
                          const notBlankPattern = /^[0-9\b]+$/;

                          // if value is not blank, then test the regex
                          if (
                            e.target.value === "" ||
                            notBlankPattern.test(e.target.value)
                          ) {
                            handleChange(e, "storeNumber", null);
                          }
                        }}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {formData.storeNumber}
                      </div>
                    )}
                  </div>
                )}
                {formData.associatedTo === "Producer" && (
                  <div className="grid grid-cols-3 ">
                    {isEdit ? (
                      <div className="expandedLabel text-left mr-2 mt-1">
                        Producer:{" "}
                        {formData.associatedTo !== "Producer" ? (
                          <></>
                        ) : (
                          <span className=" text-xs text-red-500">* </span>
                        )}
                      </div>
                    ) : (
                      <div className="expandedLabel text-left mr-2">
                        Producer:
                      </div>
                    )}
                    {isEdit ? (
                      <SelectInput_3
                        defaultValue={
                          formData.isFranchise === true
                            ? empFranchisesOpts?.filter(
                                (x) => x.value.toString() === formData.producer,
                              )
                            : confieEmpOpts?.filter(
                                (x) => x.value.toString() === formData.producer,
                              )
                        }
                        isDisabled={associatedToVal}
                        className="expandedLabel"
                        name="producer"
                        options={
                          useFormMethods.watch("isFranchise")
                            ? empFranchisesOpts
                            : confieEmpOpts
                        }
                        onChange={(e) => {
                          handleChange(e ? e.value : null, "producer", null);
                          setDefaultProducer(e);
                        }}
                        components={undefined}
                        field={undefined}
                        isLoading={undefined}
                        value={
                          formData.isFranchise === true
                            ? empFranchisesOpts?.filter(
                                (x) => x.value.toString() === formData.producer,
                              )
                            : confieEmpOpts?.filter(
                                (x) => x.value.toString() === formData.producer,
                              )
                        }
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {formData.producerName}
                      </div>
                    )}
                  </div>
                )}
                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      {formData.carrierName?.toLowerCase() ===
                      "national general"
                        ? "Princeton Code:"
                        : "Producer Code:"}{" "}
                      <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      {formData.carrierName?.toLowerCase() ===
                      "national general"
                        ? "Princeton Code:"
                        : "Producer Code:"}
                    </div>
                  )}
                  {isEdit ? (
                    <TextInput
                      type="text"
                      value={formData.producerCode}
                      className="expandedLabel"
                      name="producerCode"
                      onChange={(e) => handleChange(e, "producerCode", null)}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.producerCode}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Code Level: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Code Level:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={codeLevelOptions?.filter(
                        (x) =>
                          x.label.toUpperCase() ===
                          formData.codeLevel.toUpperCase(),
                      )}
                      className="expandedLabel"
                      name="codeLevel"
                      options={codeLevelOptions}
                      onChange={(e) =>
                        handleChange(e ? e : null, "codeLevel", null)
                      }
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.codeLevel}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Producer Sub Codes:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Producer Sub Codes:
                    </div>
                  )}
                  {isEdit ? (
                    <TextInput
                      type="text"
                      name="producerSubCodes"
                      value={formData.producerSubCodes}
                      className="expandedLabel"
                      onChange={(e) => handleChange(e, "producerSubCode", null)}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.producerSubCodes}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Line Of Business: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Line Of Business:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={loboptions?.filter(
                        (x) => x.label === formData.lineOfBusiness,
                      )}
                      className="expandedLabel"
                      name="lineOfBusiness"
                      options={loboptions}
                      onChange={(e) => handleChange(e ? e : null, "LOB", null)}
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.lineOfBusiness}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Producer Code Type:{" "}
                      <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Producer Code Type:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={prodTypesOptions?.filter(
                        (x) => x.value === formData.producerCodeTypeId,
                      )}
                      className="font-medium"
                      name="producerCodeType"
                      options={prodTypesOptions}
                      onChange={(e) =>
                        handleChange(e ? e : null, "producerCodeType", null)
                      }
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {prodTypesOptions
                        ?.filter((x) => x.value === formData.producerCodeTypeId)
                        .map((x) => x.label)}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      M&A Producer Code:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      M&A Producer Code:
                    </div>
                  )}
                  {isEdit ? (
                    <TextInput
                      value={formData.mAproducerCodes}
                      className="expandedLabel"
                      name="mAproducerCodes"
                      onChange={(e) => handleChange(e, "mAproducerCodes", null)}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.mAproducerCodes}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1 ">
                      Issued To:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Issued To:
                    </div>
                  )}
                  {isEdit ? (
                    <MultiSelectInputForProdCode
                      options={
                        useFormMethods.watch("isFranchise")
                          ? empFranchisesOpts
                          : confieEmpOpts
                      }
                      handleMultiSelect={(e) =>
                        handleChange(e ? e : null, "issuedTo", null)
                      }
                      defaultValue={undefined}
                      className="basic-multi-select expandedLabel"
                      value={selectedIssuedTo}
                    />
                  ) : (
                    <>
                      <div className="font-medium lg:text-left">
                        <div data-tip={formData.issuedToList}>
                          {formData.issuedTo}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      MGA:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">MGA:</div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={mgaList?.filter(
                        (x) => x.label === formData.mga,
                      )}
                      className="expandedLabel"
                      name="mga"
                      options={mgaList}
                      onChange={(e) => handleChange(e ? e : null, "mga", null)}
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.mga}
                    </div>
                  )}
                </div>
                {(useFormMethods.watch("isFranchise") || franchise) && (
                  <div className="grid grid-cols-3 ">
                    {isEdit ? (
                      <div className="expandedLabel text-left mr-2 mt-1">
                        Franchise Type:
                      </div>
                    ) : (
                      <div className="expandedLabel text-left mr-2">
                        Franchise Type:
                      </div>
                    )}
                    {isEdit ? (
                      <SelectInput_3
                        defaultValue={defaultFranchiseType}
                        className="expandedLabel"
                        isDisabled={
                          !associatedToVal ||
                          formData.officeCode?.toLowerCase().startsWith("z")
                        }
                        name="franchiseType"
                        options={franchiseTypeList}
                        onChange={(e) =>
                          handleChange(e ? e : null, "franchiseType", null)
                        }
                        value={defaultFranchiseType}
                        components={undefined}
                        field={undefined}
                        isLoading={undefined}
                      />
                    ) : (
                      <div className="font-medium lg:text-left">
                        {formData.franchiseType}
                      </div>
                    )}
                  </div>
                )}
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Carrier Program Name:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Carrier Program Name:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      className="expandedLabel"
                      name="program"
                      options={carrierProgramOpt?.filter(
                        (x) =>
                          x.carrierId === formData.masterCarrierID &&
                          x.isActive === true,
                      )}
                      defaultValue={(() => {
                        const val = carrierProgramOpt?.filter(
                          (x) =>
                            x.label === formData.program && x.isActive === true,
                        );
                        return val;
                      })()}
                      value={undefined}
                      onChange={(e) => {
                        handleChange(e ? e : null, "program", null);
                        setCarrierProg(e);
                      }}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.program}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Can Sell: <span className="text-red-500">*</span>
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Can Sell:
                    </div>
                  )}
                  {isEdit ? (
                    <MultiSelectInputForProdCode
                      options={allStatesOpt}
                      handleMultiSelect={(e) =>
                        handleChange(e ?? null, "crossSale", null)
                      }
                      value={selectedCrossSale}
                      className="basic-multi-select expandedLabel"
                      defaultValue={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.crossSale}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-3 ">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Billing:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">Billing:</div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      defaultValue={billingOpt?.filter(
                        (x) =>
                          x.label?.toUpperCase() ===
                          formData?.billingName?.toUpperCase(),
                      )}
                      className="expandedLabel"
                      name="billingName"
                      options={billingOpt}
                      onChange={(e) =>
                        handleChange(e ? e : null, "billingId", null)
                      }
                      value={undefined}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.billingName}
                    </div>
                  )}
                </div>
              </div>
              <div className="border-b border-gray-200"></div>
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Master Code Status:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Master Code Status:
                    </div>
                  )}
                  {isEdit ? (
                    <div className="flex">
                      <SelectInput_3
                        value={selectedMasterCodeStatus}
                        className="expandedLabel"
                        isClearable={false}
                        name="masterCodeStatus"
                        options={codeStatus}
                        onChange={(e) => {
                          handleChange(
                            e?.value ?? null,
                            "masterCodeStatus",
                            null,
                          );
                        }}
                        defaultValue={undefined}
                        components={undefined}
                        field={undefined}
                        isLoading={undefined}
                      />
                    </div>
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.masterCodeStatus}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Master Code:{" "}
                      {formData.masterCodeStatus === "Active" && (
                        <span className="text-red-500">*</span>
                      )}
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Master Code:
                    </div>
                  )}

                  {isEdit ? (
                    <SelectInput_3
                      value={selectedMasterCode}
                      className="expandedLabel"
                      isClearable={true}
                      name="masterCode"
                      options={masterCodeOpts}
                      onChange={(e) => {
                        handleChange(e ?? null, "masterCode", null);
                      }}
                      defaultValue={undefined}
                      isDisabled={formData.masterCodeStatus === "Inactive"}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.masterCode}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-3 ">
                  <div className="expandedLabel text-left mr-2 mt-1">
                    In Production:
                  </div>
                  {isEdit ? (
                    <TextInputHookFormDisabled
                      type="text"
                      value={formData.isInProduction ? "True" : "False"}
                    />
                  ) : (
                    <div className="font-medium lg:text-left mt-1">
                      {formData.isInProduction ? "True" : "False"}
                    </div>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Roll Up Code Status:
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Roll Up Code Status:
                    </div>
                  )}
                  {isEdit ? (
                    <div className="flex">
                      <SelectInput_3
                        value={selectedRollUpCodeStatus}
                        className="expandedLabel"
                        isClearable={false}
                        name="rollUpCodeStatus"
                        options={codeStatus}
                        onChange={(e) => {
                          handleChange(
                            e?.value ?? null,
                            "rollUpCodeStatus",
                            null,
                          );
                        }}
                        defaultValue={undefined}
                        components={undefined}
                        field={undefined}
                        isLoading={undefined}
                      />
                    </div>
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.rollUpCodeStatus}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3">
                  {isEdit ? (
                    <div className="expandedLabel text-left mr-2 mt-1">
                      Roll Up Code:{" "}
                      {formData.rollUpCodeStatus === "Active" && (
                        <span className="text-red-500">*</span>
                      )}
                    </div>
                  ) : (
                    <div className="expandedLabel text-left mr-2">
                      Roll Up Code:
                    </div>
                  )}
                  {isEdit ? (
                    <SelectInput_3
                      value={selectedRollUpCode}
                      className="expandedLabel"
                      isClearable={true}
                      name="rollUpCode"
                      options={rollUpCodeOpts}
                      onChange={(e) => {
                        handleChange(e ?? null, "rollUpId", e?.value);
                      }}
                      defaultValue={undefined}
                      isDisabled={formData.rollUpCodeStatus === "Inactive"}
                      components={undefined}
                      field={undefined}
                      isLoading={undefined}
                    />
                  ) : (
                    <div className="font-medium lg:text-left">
                      {formData.rollUpCodeStatus === "Active"
                        ? rollUpCodeActiveOpts &&
                          rollUpCodeActiveOpts?.filter(
                            (x) => x.label === formData.rollUpCode,
                          )[0]?.label
                        : rollUpCodeOpts &&
                          rollUpCodeOpts?.filter(
                            (x) => x.label === formData.rollUpCode,
                          )[0]?.label}
                    </div>
                  )}
                </div>
              </div>
              <div className="border-b border-gray-200"></div>

              <div className="grid grid-cols-3 gap-y-1 m-2">
                <div className="grid grid-cols-3 items-center">
                  <div
                    className={`expandedLabel text-left mr-2 ${
                      isEdit ? "mt-1" : ""
                    }`}
                  >
                    CDRC Exception:
                  </div>
                  <CheckBoxLabelHookForm
                    name="isCDRCException"
                    type="checkbox"
                    register={register}
                    readOnly={!isEdit}
                    disabled={!isEdit || isCarrierNatSafeDrivers}
                    className="disabled:cursor-default"
                    onClick={(e) => {
                      handleChange(e, "exceptionCDRC", null);
                    }}
                  />
                </div>

                <div className="grid grid-cols-3 items-center">
                  <div
                    className={`expandedLabel text-left mr-2 ${
                      isEdit ? "mt-1" : ""
                    }`}
                  >
                    Keeper Exception:
                  </div>
                  <CheckBoxLabelHookForm
                    name="isKeeperException"
                    type="checkbox"
                    readOnly={!isEdit}
                    disabled={!isEdit || isCarrierNatSafeDrivers}
                    register={register}
                    className="disabled:cursor-default"
                    onClick={(e) => {
                      handleChange(e, "exceptionKeeper", null);
                    }}
                  />
                </div>

                <div className="grid grid-cols-3 items-center">
                  <div
                    className={`expandedLabel text-left mr-2 ${
                      isEdit ? "mt-1" : ""
                    }`}
                  >
                    AL3 Exception:
                  </div>
                  <CheckBoxLabelHookForm
                    name="isAL3Exception"
                    type="checkbox"
                    readOnly={!isEdit}
                    disabled={!isEdit || isCarrierNatSafeDrivers}
                    register={register}
                    className="disabled:cursor-default font-bold"
                    onClick={(e) => {
                      handleChange(e, "exceptionAL3", null);
                    }}
                  />
                </div>
              </div>
              <div className="border-b border-gray-200"></div>

              <div className="w-full space-y-1">
                <div className="w-full items-start gap-2">
                  <div
                    className={
                      "expandedLabel text-left mr-2 " + (isEdit ? "mt-1" : "")
                    }
                  >
                    Notes:
                  </div>

                  {isEdit ? (
                    <div className="col-span-2">
                      <TextAreaHookForm
                        value={formData.notes}
                        onChange={(e) => {
                          handleChange(e, "notes", null);
                        }}
                        name="notes"
                        placeholder="Type here"
                        {...({
                          className:
                            "expandedLabel border border-gray-300 col-span-2 rounded-sm text-xs",
                          maxLength: maxLength,
                        } as any)}
                      />

                      <div className="flex justify-between items-center gap-2 text-xs mt-1">
                        {isNotesTooLong && (
                          <span className="text-red-500">
                            Notes cannot exceed {maxLength} characters
                          </span>
                        )}

                        <span
                          className={
                            isNotesTooLong ? "text-red-500" : "text-gray-500"
                          }
                        >
                          {notesValue.length} / {maxLength}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="font-medium lg:text-left">
                      <pre className="whitespace-pre-wrap break-words hyphens-auto">
                        {formData.notes}
                      </pre>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-96">
          <CustomLoader />
        </div>
      )}
    </div>
  );
};
